// extracted by mini-css-extract-plugin
export default {"cameraWrapper":"Camera_cameraWrapper__UmLl2","centeredImage":"Camera_centeredImage__LPvLJ"};